import AutoAbstractField from "./AutoAbstractField.mjs";
import Select from "react-select";
import G from "../../libs/Glob.mjs";

const AutoSelectField = class extends AutoAbstractField {
	constructor(props) {
		super(props);
		this.state.options = (props.def.options||[])
			.map( b => {
				if ( typeof b !== 'object' ) b = { value: b };
				if ( ! b.label ) b.label = String(b.value);
				return b;
			});
	}
	renderField() {
		let v = this.state.value;
		if ( Array.isArray(v) ) v = v.shift();
		return(
			<div>
				<Select
					options={this.state.options}
					placeholder={ G.label('Select') }
					value={ this.state.options.find( o => o.value === v) }
					menuPortalTarget={document.body}
					isClearable={true}
					styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
					onChange={o=>{
						this.state.fh.setValue(o?.value );
					}}
				/>
			</div>
		)
	}
}

export default AutoSelectField;
